import { useEffect } from 'react';
import { toast } from '~/utils/toast';

const useExternalPopup = (
  externalPopup: Window | null,
  setExternalPopup: React.Dispatch<React.SetStateAction<Window | null>>,
  provider: string,
  closeModalFunc: () => void,
) => {
  useEffect(() => {
    if (!externalPopup) {
      return;
    }

    const timer = setInterval(() => {
      if (!externalPopup) {
        timer && clearInterval(timer);
        return;
      }
      const currentUrl = externalPopup.location.href;
      if (!currentUrl) {
        return;
      }
      const searchParams = new URL(currentUrl).searchParams;
      const code = searchParams.get('code');
      const error = searchParams.get('error');

      if (code ?? error) {
        externalPopup.close();
        setExternalPopup(null);
        timer && clearInterval(timer);
        if (error) {
          toast.error(error);
        } else {
          toast.success(`Successfully connected to ${provider}`);
          closeModalFunc();
        }
      }
    }, 1000);
  }, [externalPopup, provider, setExternalPopup, closeModalFunc]);
};

export default useExternalPopup;
